import React from "react";
import BuildIcon from "@mui/icons-material/Build";
import PlaceIcon from "@mui/icons-material/Place";
import TopicIcon from "@mui/icons-material/Topic";
import PersonIcon from "@mui/icons-material/Person";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ApprovalIcon from "@mui/icons-material/Approval";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsIcon from "@mui/icons-material/Settings";
import EventNoteIcon from "@mui/icons-material/EventNote";
import InventoryIcon from "@mui/icons-material/Inventory";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import TableChartIcon from "@mui/icons-material/TableChart";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ChecklistIcon from "@mui/icons-material/Checklist";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { EndPoints } from "../../utils/apiEndpoints";
import { GroupInterface } from "../../domain/helpers/NavMenuItem";

const iconCss = { width: "22px", height: "22px" };
export const navBarItems: GroupInterface[] = [
  {
    groupName: "none",
    items: [
      {
        id: 1,
        name: "Dashboards",
        icon: <HomeOutlinedIcon className="me-2" />,
        route: EndPoints.ANALYTICS,
        role: "Employee",
      },
    ],
  },
  {
    groupName: "APPS&PAGES",
    items: [
      {
        id: 1,
        name: "Tickets",
        icon: <ReceiptLongOutlinedIcon sx={iconCss} className="me-2" />,
        route: EndPoints.TICKETS,
        role: "Employee",
      },
      {
        id: 2,
        name: "TicketCalendar",
        icon: <EventNoteIcon sx={iconCss} className="me-2" />,
        route: EndPoints.TICKETCALENDARS,
        role: "Employee",
      },
      {
        id: 3,
        name: "CallCenter",
        icon: <HeadsetMicOutlinedIcon sx={iconCss} className="me-2" />,
        route: EndPoints.INCIDENTS,
        role: "Employee",
      },
      {
        id: 4,
        name: "Assets",
        icon: <InventoryIcon sx={iconCss} className="me-2" />,
        route: EndPoints.ASSETS,
        role: "Admin",
      },
      {
        id: 5,
        name: "Procurement",
        icon: <ShoppingCartOutlinedIcon sx={iconCss} className="me-2" />,
        role: "Employee",
        subMenu: [
          {
            id: 1,
            name: "PurchaseOrders",
            icon: <LocalOfferIcon sx={iconCss} className="me-2" />,
            route: EndPoints.PURCHASEORDERS,
          },
          {
            id: 2,
            name: "PendingRequests",
            route: EndPoints.PENDINGREQUESTS,
            icon: <CheckCircleIcon sx={iconCss} className="me-2" />,
          },
          {
            id: 3,
            name: "PurchaseRequests",
            route: EndPoints.PURCHASEREQUESTS,
            icon: <CheckCircleIcon sx={iconCss} className="me-2" />,
          },
          {
            id: 4,
            name: "RequestForProposals",
            route: EndPoints.REQUESTFORPROPOSAL,
            icon: <CheckCircleIcon sx={iconCss} className="me-2" />,
          },
          {
            id: 5,
            name: "RequestForQuotations",
            route: EndPoints.REQUESTFORQUOTATION,
            icon: <CheckCircleIcon sx={iconCss} className="me-2" />,
          },
        ],
      },
      {
        id: 6,
        name: "Users",
        icon: <GroupOutlinedIcon sx={iconCss} className="me-2" />,
        role: "Admin",
        subMenu: [
          {
            id: 1,
            name: "Users",
            icon: <GroupOutlinedIcon sx={iconCss} className="me-2" />,
            route: EndPoints.USERS,
          },
          {
            id: 2,
            name: "ManageUsers",
            route: EndPoints.MANAGEUSERS,
            icon: <ManageAccountsIcon sx={iconCss} className="me-2" />,
          },
        ],
      },
      {
        id: 7,
        name: "Raports",
        icon: <TableChartIcon sx={iconCss} className="me-2" />,
        role: "Admin",
        subMenu: [
          {
            id: 1,
            name: "Tickets",
            route: EndPoints.TICKETRAPORTS,
            icon: <ReceiptLongOutlinedIcon sx={iconCss} className="me-2" />,
          },
          {
            id: 2,
            name: "Assets",
            route: EndPoints.ASSETSRAPORTS,
            icon: <InventoryIcon sx={iconCss} className="me-2" />,
          },
        ],
      },
    ],
  },
  {
    groupName: "SETTINGS",
    items: [
      {
        id: 1,
        name: "Settings",
        icon: <SettingsIcon sx={iconCss} className="me-2" />,
        role: "Admin",
        subMenuSettings: [
          {
            id: 1,
            name: "Tickets",
            role: "Admin",
            subMenuItemSettings: [
              {
                id: 1,
                name: "RecurringTickets",
                route: EndPoints.RECURRINGTICKETS,
                icon: <EventRepeatIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 2,
                name: "Categories",
                route: EndPoints.CATEGORIES,
                icon: <ClassOutlinedIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 3,
                name: "Contractors",
                route: EndPoints.CONTRACTORS,
                icon: <WorkOutlineOutlinedIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 4,
                name: "Customers",
                route: EndPoints.CUSTOMERS,
                icon: <PersonIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 5,
                name: "InterventionType",
                route: EndPoints.INTERVENTIONTYPE,
                icon: <BuildIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 6,
                name: "Locations",
                route: EndPoints.LOCATIONS,
                icon: <PlaceIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 7,
                name: "Statuses",
                route: EndPoints.STATUSES,
                icon: <AssessmentIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 8,
                name: "Priorities",
                route: EndPoints.PRIORITIES,
                icon: <PriorityHighIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 9,
                name: "Departments",
                route: EndPoints.DEPARTMENTS,
                icon: <BusinessIcon sx={iconCss} className="me-2" />,
              },
            ],
          },
          {
            id: 2,
            name: "Assets",
            role: "Admin",
            subMenuItemSettings: [
              {
                id: 1,
                name: "AssetDepartments",
                route: EndPoints.ASSETDEPARTMENTS,
                icon: <BusinessIcon sx={iconCss} className="me-2" />,
              },
              // {
              //   id: 2,
              //   name: "AssetLocations",
              //   route: EndPoints.ASSETLOCATIONS,
              //   icon: <PlaceIcon sx={iconCss} className="me-2" />,
              // },
              {
                id: 3,
                name: "AssetCategories",
                route: EndPoints.ASSETCATEGORIES,
                icon: <ClassOutlinedIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 4,
                name: "AssetTypes",
                route: EndPoints.ASSETTYPES,
                icon: <BookmarksIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 5,
                name: "AssetStatuses",
                route: EndPoints.ASSETSTATUSES,
                icon: <AssessmentIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 6,
                name: "AssetActionTypes",
                route: EndPoints.ASSETACTIONTYPES,
                icon: <AssessmentIcon sx={iconCss} className="me-2" />,
              },
            ],
          },
          {
            id: 3,
            name: "Procurements",
            role: "Admin",
            subMenuItemSettings: [
              {
                id: 1,
                name: "Vendors",
                route: EndPoints.VENDORS,
                icon: <StorefrontOutlinedIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 2,
                name: "VendorStatuses",
                route: EndPoints.VENDORSTATUSES,
                icon: <TaskAltIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 3,
                name: "PurchaseOrderType",
                route: EndPoints.PURCHASEORDERTYPES,
                icon: <ReceiptIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 4,
                name: "ApprovalPersons",
                route: EndPoints.APPROVALPERSONS,
                icon: <ApprovalIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 5,
                name: "EvaluationCriterias",
                route: EndPoints.EVALUATIONCRITERIAS,
                icon: <ChecklistIcon sx={iconCss} className="me-2" />,
              },
            ],
          },
          {
            id: 4,
            name: "General",
            role: "Admin",
            subMenuItemSettings: [
              {
                id: 1,
                name: "CompanyNews",
                route: EndPoints.COMPANYNEWS,
                icon: <NewspaperIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 2,
                name: "Companies",
                route: EndPoints.COMPANY,
                icon: <BusinessIcon sx={iconCss} className="me-2" />,
              },
              {
                id: 3,
                name: "DocumentTemplate",
                route: EndPoints.DOCUMENTTEMPLATE,
                icon: <TopicIcon sx={iconCss} className="me-2" />,
              },
            ],
          },
        ],
      },
    ],
  },
];
